import { convert, getUnitLabel } from '#lib/intlUnits.js';
import { unitSystemStore } from '#lib/stores/unitSystemStore.svelte.js';
import { PATCH_FALLBACK, prioritizeColours } from '#lib/vizPalette.js';
import { mapPriorityDescription } from '../prioritize';

// Swatch colour for a raw priority rating, matching the Prioritize layer.
export const priorityColor = (rating: string) =>
	prioritizeColours.find((p) => p.key === mapPriorityDescription[rating])?.color ?? PATCH_FALLBACK;

export const money = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0
});

export const BACKLOG_SUBTITLE = 'Drafted projects not yet in a program';

export const dateFmt = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' });

export const pct = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 0 });

// Stopgap KA risk as "existing → after", each a share of the untreated baseline; null until worked out.
export const riskRange = (risk: { existing: number; final: number } | null) =>
	risk ? `${pct.format(risk.existing)} → ${pct.format(risk.final)}` : '—';

// Milepost: project km in the user's big-length unit.
export function fmtMp(km: number): string {
	return convert(km, 'bigLength', 'metric', unitSystemStore.systemFor('bigLength')).toFixed(1);
}

export function lengthParts(km: number): { value: string; unit: string } {
	return {
		value: fmtMp(km),
		unit: getUnitLabel('bigLength', unitSystemStore.systemFor('bigLength'))
	};
}

export function fmtLength(km: number): string {
	const { value, unit } = lengthParts(km);
	return `${value} ${unit}`;
}

// A finite non-negative number input value, or undefined after reverting the input to `fallback`.
export function nonNeg(el: HTMLInputElement, fallback: number): number | undefined {
	const v = el.valueAsNumber;
	if (Number.isFinite(v) && v >= 0) return v;
	el.value = String(fallback);
	return undefined;
}
